module.exports = __webpack_public_path__ + "img/login_form.ca174012.png";